<script lang="ts">
  import { onDestroy, onMount } from "svelte";

  export let id: string|null = null;
  export let cls: string = null;
  export let sub_cls: string = null;
  export let hide_body_padding: boolean = false;
  export let hide_header_padding: boolean = false;
  export let shown = false;
  export let header: boolean = true;
  export let footer: boolean = true;
  export let closeButtonText: string = 'Close';
  export let maxWidthStyleString: string | null = null;
  export let modalFitContent: boolean = false;
  export let onModalClosed: () => void = () => {};

  export let showXButton: boolean = true;
  //@ts-ignore
  let jq = window.$;
  let modal: HTMLElement;
  export function close() {
    jq(modal).trigger("click.dismiss.bs.modal");
  }
  export function toggle() {
    jq(modal).modal('toggle');
  }
  export function show() {
    jq(modal).modal('show');
  }
  onMount(()=>{
    jq(modal).on('show.bs.modal', ()=>shown=true)
    jq(modal).on('hidden.bs.modal', ()=>{shown=false; onModalClosed()})

  })
  onDestroy(()=>{
    jq(modal).off('show.bs.modal')
    jq(modal).off('hidden.bs.modal')

  })
</script>

<!-- Modal -->
<modal bind:this={modal} {id} class="modal fade{cls ? " "+cls : ""}" role="dialog">
  <div class="modal-dialog{sub_cls ? " "+sub_cls : ""}" style={maxWidthStyleString ? `width: ${modalFitContent ? 'fit-content' : 'auto'}; max-width: ${maxWidthStyleString}` : ''}>

    <!-- Modal content-->
    <div class="modal-content">
      {#if header}
        <div class="modal-header" class:p-0={hide_header_padding}>
            {#if $$slots.customHeader}
              <slot name="customHeader"/>
            {:else}
            <h3 class="modal-title">    
              <slot name="title"/>
            </h3>
            {/if}
            {#if showXButton}
              <button type="button" class="modal-close" class:modal-close-btn={$$slots.customHeader} data-dismiss="modal"></button>
            {/if}
        </div>
      {/if}
      <div class="modal-body" style={hide_body_padding ? "padding: 0" : ""}>
        <slot/>
      </div>
      {#if footer}
        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">{closeButtonText}</button>
          </slot>
        </div>
      {/if}
    </div>
  </div>
</modal>

<style>
  .modal-content {
      max-height: 100%;
      display: flex;
      flex-flow: column nowrap;
  }
  .modal-body {
      overflow-x: none;
      flex-grow: 1;
  }
  .modal-close-btn {
    margin: 0 25px;
  }
</style>
